// extracted by mini-css-extract-plugin
module.exports = {"container":"Heading_container___Di4e","bold":"Heading_bold__IfFDX","regular":"Heading_regular__f_vGk"};